(function(){
  const root = document.getElementById('aval-step3');
  if (!root || root.__avalStep3Booted) return;

  const config = window.AVAL?.readConfig?.('aval-step3-config') || {};
  const KEY_STEP1 = 'aval_booking_step1';
  const KEY_STEP2 = 'aval_booking_step2';
  const KEY_STEP3 = 'aval_booking_step3';
  const KEY_ALL = 'aval_booking_all';
  const PAYMENT_KEYS = ['avalPayment', 'aval_payment_amount_brutto', 'aval_payment_pending'];

  const BACK_URL = String(config.backUrl || '/pages/transport-sendung?resume=1');
  const STEP1_URL = String(config.step1Url || '/pages/jetzt-preis-fur-kurierfahrt-kalkulieren?resume=1');
  const NEXT_URL = String(config.nextUrl || '/pages/zahlungsart-auswaehlen');
  const USE_PERSISTENT_FALLBACK = config.persistentStorageFallback === true;

  const els = {
    summaryBox: document.getElementById('summaryBox'),
    togPrivate: document.getElementById('togPrivate'),
    togBusiness: document.getElementById('togBusiness'),
    firmaWrap: document.getElementById('firmaWrap'),
    form: document.getElementById('kontaktForm'),
    nextBtn: document.getElementById('nextBtn'),
    ctaHint: document.getElementById('ctaHint'),
    globalErr: document.getElementById('globalErr'),
    firma: document.getElementById('firma'),
    name: document.getElementById('name'),
    adresse: document.getElementById('adresse'),
    telefon: document.getElementById('telefon'),
    email: document.getElementById('email'),
    hinweise: document.getElementById('hinweise'),
    datenschutz: document.getElementById('datenschutz'),
    err_firma: document.getElementById('err_firma'),
    err_name: document.getElementById('err_name'),
    err_adresse: document.getElementById('err_adresse'),
    err_telefon: document.getElementById('err_telefon'),
    err_email: document.getElementById('err_email'),
    err_datenschutz: document.getElementById('err_datenschutz')
  };

  let customerType = 'private';
  let hasTriedSubmit = false;
  let isRestoring = false;
  let isSubmitting = false;
  let step1 = null;
  let step2 = null;
  let billingPlace = null;
  let createdAt = new Date().toISOString();
  let saveTimer = null;

  const bookingCore = window.AVAL?.booking;
  if (!bookingCore) return;
  root.__avalStep3Booted = true;
  const bookingStorage = bookingCore.createStorage({ persistentFallback: USE_PERSISTENT_FALLBACK });
  const {
    normalizeText,
    escapeHtml,
    toNumber,
    round2,
    formatEUR: fmtEUR,
    formatDateDE: fmtDate,
    formatArt,
    formatTimeWindowHtml: fmtTimeWindow,
    buildResumeUrl,
    step2Signature: createStep2Signature,
    step2PriceStructureSignature: createStep2PriceStructureSignature,
    sanitizePriceRows,
    getZollSurcharge: resolveZollSurcharge
  } = bookingCore;
  const avalLoad = bookingStorage.readJSON;
  const avalSave = bookingStorage.writeJSON;
  const avalRemove = bookingStorage.remove;

  function clearKeys(keys){
    keys.forEach(avalRemove);
  }

  function clearDownstreamData(){
    clearKeys([KEY_ALL].concat(PAYMENT_KEYS));
  }

  function notEmpty(v){
    return normalizeText(v).length > 0;
  }



  function getZollSurcharge(){
    return resolveZollSurcharge(step2);
  }


  function getPriceRows(){
    const storedRows = sanitizePriceRows(step2?.preis_zeilen);
    if (storedRows.length) return storedRows;

    if (isRequestMode()) return [];

    const total = getBasePrice();
    const basisRaw = toNumber(step2?.preis_basis);
    const basis = Number.isFinite(basisRaw) && basisRaw > 0 ? round2(basisRaw) : total;
    const zoll = getZollSurcharge();
    const rows = [];

    if (basis > 0 && (zoll > 0 || Math.abs(total - basis) > 0.01)) {
      rows.push({ key: 'transport', label: 'Transportpreis netto', amount: basis, total: false });

      if (zoll > 0) {
        rows.push({ key: 'zoll', label: 'Zollabwicklung netto', amount: zoll, total: false });
      }

      rows.push({ key: 'net_total', label: 'Gesamt netto', amount: total, total: true });
    } else if (total > 0) {
      rows.push({ key: 'transport', label: 'Transportpreis netto', amount: total, total: true });
    }

    return rows;
  }

  function buildPriceSnapshot(){
    const rows = getPriceRows();
    const comps = step2?.preis_komponenten && typeof step2.preis_komponenten === 'object'
      ? step2.preis_komponenten
      : null;

    return {
      v: 1,
      source: 'aval-step3',
      currency: 'EUR',
      pricing_version: step2?.pricing_version || comps?.pricing_version || step1?.pricing_version || '',
      step1_price_signature: step1?.price_signature || '',
      step2_signature: step2Signature(),
      step2_price_structure_signature: step2PriceStructureSignature(),
      preis_basis: round2(step2?.preis_basis ?? step1?.preis ?? 0),
      preis_total: round2(step2?.preis_total ?? step1?.preis ?? 0),
      preis_komponenten: comps,
      preis_zeilen: rows.map(row => ({
        key: row.key,
        label: row.label,
        amount: round2(row.amount).toFixed(2),
        total: row.total === true
      })),
      zuschlaege: step2?.zuschlaege || {},
      request_mode: isRequestMode(),
      captured_at: new Date().toISOString()
    };
  }

  function renderPriceBreakdown(){
    if (isRequestMode()) {
      return `
        <p class="summary-spaced">
          <strong>Preis:</strong> <span class="summary-muted">wird vor Zahlung transparent bestätigt.</span>
        </p>
      `;
    }

    const net = round2(step2?.preis_total ?? step1?.preis ?? 0);

    if (!(net > 0)) {
      return `<p class="summary-spaced"><strong>Preis:</strong> <span class="summary-muted">wird vor Zahlung transparent bestätigt.</span></p>`;
    }

    const VAT_RATE = 0.19;
    const vat = round2(net * VAT_RATE);
    const gross = round2(net + vat);

    const rows = [
  { key: 'net_total', label: 'Nettobetrag:', amount: net, bold: true },
  { key: 'vat_total', label: 'MwSt. (19 %):', amount: vat, bold: true },
  { key: 'gross_total', label: 'Bruttobetrag:', amount: gross, total: true }
];

    const rowsHtml = rows.map(row => `
      <div class="price-line${row.total ? ' total' : ''}">
        <span>${row.bold ? `<strong>${escapeHtml(row.label)}</strong>` : escapeHtml(row.label)}</span>
        <strong>${escapeHtml(fmtEUR(row.amount))} €</strong>
      </div>
    `).join('');

    let note = '';

    const dupes = Math.max(0, Math.round(Number(step2?.preis_komponenten?.duplicate_stop_count) || 0));
    if (dupes > 0) {
      note += `<div class="price-note">Hinweis: ${escapeHtml(String(dupes))} doppelt erkannte physische Adresse wurde für die Zusatzstopp-Bepreisung nicht doppelt berechnet.</div>`;
    }

    return `
      <div class="price-breakdown" aria-label="Preisübersicht">
        ${rowsHtml}
      </div>
      ${note}
    `;
  }

  function renderShipmentCheck(){
    const check = step2?.sendungspruefung;
    if (!check || typeof check !== 'object') return '';

    const fits = check.fits_vehicle === true;
    const weight = Number.isFinite(toNumber(check.total_weight_kg)) ? fmtEUR(check.total_weight_kg).replace(',00', '') : '–';
    const load = Number.isFinite(toNumber(check.load_floor_pct)) ? fmtEUR(check.load_floor_pct).replace(',00', '') : '–';

    return `
      <div class="shipment-check">
        <strong>T6.1-Passprüfung:</strong> ${fits ? 'bestanden' : 'bitte Sendungsdetails prüfen'}<br>
        Gesamtgewicht: ${escapeHtml(weight)} kg · Ladefläche: ${escapeHtml(load)} % · Preis unabhängig von Gewicht und Maßen.
      </div>
    `;
  }




  function normalizePhone(v){
    let s = String(v || '')
      .replace(/[^\d+()\-\s/]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    const plus = s.startsWith('+') ? '+' : '';
    s = plus + s.replace(/\+/g, '');

    return s.trim();
  }

  function isPhone(v){
    const s = normalizePhone(v);
    const digits = s.replace(/[^\d]/g, '');

    return digits.length >= 7 && digits.length <= 18;
  }

  function isEmail(v){
    const s = String(v || '').trim().toLowerCase();

    if (s.length < 6 || s.length > 254) return false;
    if (/\s/.test(s)) return false;

    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s);
  }

  function looksCompleteBillingAddress(v){
    const s = normalizeText(v);

    if (s.length < 8) return false;

    const hasZip = /\b\d{5}\b/.test(s);
    const hasDigit = /\d/.test(s);
    const hasLetter = /[A-Za-zÄÖÜäöüß]/.test(s);

    return hasZip && hasDigit && hasLetter;
  }

  function showGlobal(msg){
    els.globalErr.textContent = msg || '';
    els.globalErr.style.display = msg ? 'block' : 'none';
  }

  function getBookingId(){
    return String(step1?.booking_id || '').trim();
  }

  function getBasePrice(){
    if (step1?.request_mode === true || step2?.request_mode === true) return 0;

    const raw = step2?.preis_total ?? step1?.preis ?? '';
    const n = toNumber(raw);

    return Number.isFinite(n) && n > 0 ? Math.round(n * 100) / 100 : 0;
  }

  function isRequestMode(){
    if (step2?.request_mode === true) return true;
    if (step1?.request_mode === true) return true;

    return getBasePrice() <= 0;
  }

  function getStep1Availability(){
    return step1 && typeof step1.availability === 'object' && step1.availability
      ? step1.availability
      : null;
  }

  function step1RequiresAvailability(){
    if (!step1) return true;
    if (step1.availability_required === false) return false;

    const av = getStep1Availability();
    if (av && av.required === false) return false;

    return true;
  }

  function availabilityHoldExpiresAtMs(){
    const av = getStep1Availability();
    const ms = Date.parse(av?.hold_expires_at || '');
    return Number.isFinite(ms) ? ms : NaN;
  }

  function hasValidStep1Base(){
    const abhol = Array.isArray(step1?.abholstopps) ? step1.abholstopps : [];
    const zust = Array.isArray(step1?.zustellstopps) ? step1.zustellstopps : [];

    const hasPickup = abhol.some(s => normalizeText(s?.adresse || ''));
    const hasDrop = zust.some(s => normalizeText(s?.adresse || ''));
    const hasDates = !!(step1?.datum_abholung && step1?.datum_zustellung);
    const hasPriceState = toNumber(step1?.preis) > 0;
    const hasPriceSignature = !!step1?.price_signature;
    const notRequestMode = step1?.request_mode !== true;

    return !!(
      step1 &&
      getBookingId() &&
      hasPickup &&
      hasDrop &&
      hasDates &&
      hasPriceState &&
      hasPriceSignature &&
      notRequestMode
    );
  }

  function hasValidStep1Availability(){
    if (!step1RequiresAvailability()) return true;

    const av = getStep1Availability();
    const expMs = availabilityHoldExpiresAtMs();

    return !!(
      step1?.availability_valid === true &&
      av &&
      av.available === true &&
      normalizeText(av.hold_id || '') &&
      normalizeText(av.signature || '') &&
      Number.isFinite(expMs) &&
      expMs > Date.now()
    );
  }

  function step1AvailabilityProblemMessage(){
    if (!hasValidStep1Base()) {
      return 'Ihre Streckendaten konnten nicht vollständig geladen werden. Bitte gehen Sie zurück zu Schritt 1 und kalkulieren Sie die Strecke erneut.';
    }

    if (!step1RequiresAvailability()) return '';

    const av = getStep1Availability();

    if (!av) {
      return 'Die Fahrzeugverfügbarkeit konnte nicht geladen werden. Bitte gehen Sie zurück zu Schritt 1 und prüfen Sie Preis und Verfügbarkeit erneut.';
    }

    if (step1?.availability_valid !== true || av.available !== true) {
      return 'Das gewählte Zeitfenster ist nicht gültig als verfügbar bestätigt. Bitte gehen Sie zurück zu Schritt 1 und prüfen Sie Preis und Verfügbarkeit erneut.';
    }

    if (!normalizeText(av.hold_id || '')) {
      return 'Die Zeitfensterreservierung fehlt. Bitte gehen Sie zurück zu Schritt 1 und reservieren Sie das verfügbare Zeitfenster erneut.';
    }

    const expMs = availabilityHoldExpiresAtMs();

    if (!Number.isFinite(expMs)) {
      return 'Die Gültigkeit der Zeitfensterreservierung konnte nicht geprüft werden. Bitte gehen Sie zurück zu Schritt 1 und prüfen Sie erneut.';
    }

    if (expMs <= Date.now()) {
      return 'Die Zeitfensterreservierung ist abgelaufen. Bitte gehen Sie zurück zu Schritt 1 und prüfen Sie Preis und Verfügbarkeit erneut.';
    }

    return 'Bitte gehen Sie zurück zu Schritt 1 und prüfen Sie Preis und Verfügbarkeit erneut.';
  }

  function hasValidStep1(){
    return hasValidStep1Base() && hasValidStep1Availability();
  }

  function step2Signature(){
    return createStep2Signature(step2);
  }

  function step2PriceStructureSignature(){
    return createStep2PriceStructureSignature(step2, getPriceRows(), getZollSurcharge());
  }

  function hasValidStep2Base(){
    if (!step2 || typeof step2 !== 'object') return false;
    if (step2.booking_id !== getBookingId()) return false;
    if (step2.valid !== true) return false;

    if (step1?.price_signature && step2.step1_price_signature && step2.step1_price_signature !== step1.price_signature) {
      return false;
    }

    return Array.isArray(step2.packstuecke) && step2.packstuecke.length > 0;
  }

  function hasValidStep2Availability(){
    if (!step1RequiresAvailability()) return true;
    if (!hasValidStep1Availability()) return false;

    const av = getStep1Availability();
    const currentSignature = av?.signature || '';
    const currentHoldId = av?.hold_id || '';
    const step2SignatureValue = step2?.step1_availability_signature || step2?.availability_snapshot?.signature || '';
    const step2HoldId = step2?.availability_hold_id || step2?.availability_snapshot?.hold_id || '';
    const step2ExpMs = Date.parse(step2?.availability_hold_expires_at || step2?.availability_snapshot?.hold_expires_at || '');

    return !!(
      step2?.step1_availability_valid === true &&
      step2SignatureValue &&
      currentSignature &&
      step2SignatureValue === currentSignature &&
      step2HoldId &&
      currentHoldId &&
      step2HoldId === currentHoldId &&
      Number.isFinite(step2ExpMs) &&
      step2ExpMs > Date.now()
    );
  }

  function step2AvailabilityProblemMessage(){
    if (!hasValidStep2Base()) {
      return 'Ihre Sendungsdaten konnten nicht vollständig oder nicht konsistent geladen werden. Bitte gehen Sie zurück zu Schritt 2 und prüfen Sie Ihre Sendungsdetails.';
    }

    if (!step1RequiresAvailability()) return '';

    if (!hasValidStep1Availability()) {
      return step1AvailabilityProblemMessage();
    }

    const av = getStep1Availability();
    const currentSignature = av?.signature || '';
    const currentHoldId = av?.hold_id || '';
    const step2SignatureValue = step2?.step1_availability_signature || step2?.availability_snapshot?.signature || '';
    const step2HoldId = step2?.availability_hold_id || step2?.availability_snapshot?.hold_id || '';

    if (step2?.step1_availability_valid !== true) {
      return 'Die Sendungsdaten enthalten keine gültige Zeitfensterreservierung. Bitte gehen Sie zurück zu Schritt 2 oder Schritt 1 und prüfen Sie die Buchung erneut.';
    }

    if (!step2SignatureValue || !currentSignature || step2SignatureValue !== currentSignature) {
      return 'Die Sendungsdaten passen nicht mehr zur aktuellen Zeitfensterprüfung. Bitte gehen Sie zurück zu Schritt 2 oder Schritt 1 und prüfen Sie die Buchung erneut.';
    }

    if (!step2HoldId || !currentHoldId || step2HoldId !== currentHoldId) {
      return 'Die gespeicherte Zeitfensterreservierung passt nicht mehr zu dieser Buchung. Bitte gehen Sie zurück zu Schritt 1 und reservieren Sie das Zeitfenster erneut.';
    }

    const step2ExpMs = Date.parse(step2?.availability_hold_expires_at || step2?.availability_snapshot?.hold_expires_at || '');

    if (!Number.isFinite(step2ExpMs) || step2ExpMs <= Date.now()) {
      return 'Die Zeitfensterreservierung ist abgelaufen. Bitte gehen Sie zurück zu Schritt 1 und prüfen Sie Preis und Verfügbarkeit erneut.';
    }

    return 'Bitte prüfen Sie die vorherigen Buchungsschritte erneut.';
  }

  function hasValidStep2(){
    return hasValidStep2Base() && hasValidStep2Availability();
  }

  function buildBackUrl(){
    return buildResumeUrl(BACK_URL);
  }

  function goBackToStep2(){
    location.href = buildBackUrl();
  }

  function buildStep1Url(){
    try {
      const url = new URL(STEP1_URL, window.location.origin);
      url.searchParams.set('resume', '1');

      if (url.origin === window.location.origin) {
        return url.pathname + url.search + url.hash;
      }

      return url.toString();
    } catch(e) {
      return STEP1_URL.indexOf('?') === -1 ? STEP1_URL + '?resume=1' : STEP1_URL + '&resume=1';
    }
  }

  function goBackToStep1(){
    location.href = buildStep1Url();
  }

  function clearFieldError(input, errEl){
    if (!input || !errEl) return;

    const label = root.querySelector(`label[for="${input.id}"]`);

    input.classList.remove('input-error');
    input.removeAttribute('aria-invalid');
    errEl.textContent = '';
    errEl.style.display = 'none';

    if (label) label.classList.remove('is-invalid');
  }

  function setFieldError(input, errEl, msg, show){
    if (!input || !errEl || !show) return;

    const label = root.querySelector(`label[for="${input.id}"]`);

    if (msg) {
      input.classList.add('input-error');
      input.setAttribute('aria-invalid', 'true');
      errEl.textContent = msg;
      errEl.style.display = 'block';

      if (label && label.classList.contains('req')) label.classList.add('is-invalid');
    } else {
      clearFieldError(input, errEl);
    }
  }

  function clearAllFieldErrors(){
    [
      [els.firma, els.err_firma],
      [els.name, els.err_name],
      [els.adresse, els.err_adresse],
      [els.telefon, els.err_telefon],
      [els.email, els.err_email],
      [els.datenschutz, els.err_datenschutz]
    ].forEach(pair => clearFieldError(pair[0], pair[1]));
  }

  function firstErrorElement(){
    return root.querySelector('.input-error') || root.querySelector('[aria-invalid="true"]');
  }

  function focusAndScrollTo(el){
    if (!el) return;

    try {
      el.focus({ preventScroll: true });
    } catch(e) {
      try { el.focus(); } catch(e2) {}
    }

    try {
      const y = el.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: y, behavior: 'smooth' });
    } catch(e) {}
  }

  function formatFromComps(comps){
    const arr = Array.isArray(comps) ? comps : [];
    const get = type => {
      const c = arr.find(x => (x.types || []).includes(type));
      return (c && (c.long_name || c.short_name)) || '';
    };

    const street = get('route');
    const no = get('street_number');
    const postal = get('postal_code');
    const city =
      get('locality') ||
      get('postal_town') ||
      get('administrative_area_level_2') ||
      get('administrative_area_level_3');

    if (!street && !postal && city) return city;
    if (!street && postal) return city ? `${postal} ${city}` : postal;

    if (street && !no) {
      const tail = postal && city ? `${postal} ${city}` : (city || postal || '');
      return tail ? `${street}, ${tail}` : street;
    }

    if (street && no) {
      const head = `${street} ${no}`.trim();
      const tail = postal && city ? `${postal} ${city}` : (city || postal || '');
      return tail ? `${head}, ${tail}` : head;
    }

    if (postal && city) return `${postal} ${city}`;

    return city || postal || '';
  }

  function formatPlaceOrResult(obj, fallbackText){
    const formatted = formatFromComps(obj?.address_components || []);

    if (formatted) return formatted;

    const fa = String(obj?.formatted_address || '').trim();

    return fa || String(fallbackText || '').trim();
  }

  function renderMissingData(){
    let title = 'Ihre bisherigen Buchungsdaten konnten nicht vollständig geladen werden.';
    let message = 'Bitte gehen Sie zurück zu Schritt 2 und prüfen Sie Ihre Sendungsdetails.';
    let buttonText = 'Zurück zu Sendung';
    let buttonId = 'backToStep2_inline';
    let handler = goBackToStep2;

    if (!hasValidStep1Base()) {
      title = 'Ihre Streckendaten konnten nicht vollständig geladen werden.';
      message = 'Bitte gehen Sie zurück zu Schritt 1 und kalkulieren Sie die Strecke erneut.';
      buttonText = 'Zurück zu Strecke';
      buttonId = 'backToStep1_inline';
      handler = goBackToStep1;
    } else if (!hasValidStep1Availability()) {
      title = 'Ihre Zeitfensterreservierung ist nicht mehr gültig.';
      message = step1AvailabilityProblemMessage();
      buttonText = 'Zurück zu Preis & Verfügbarkeit';
      buttonId = 'backToStep1_inline';
      handler = goBackToStep1;
    } else if (!hasValidStep2Base()) {
      title = 'Ihre Sendungsdaten konnten nicht vollständig geladen werden.';
      message = 'Bitte gehen Sie zurück zu Schritt 2 und prüfen Sie Ihre Sendungsdetails.';
      buttonText = 'Zurück zu Sendung';
      buttonId = 'backToStep2_inline';
      handler = goBackToStep2;
    } else if (!hasValidStep2Availability()) {
      title = 'Die Zeitfensterreservierung passt nicht mehr zu Ihren Sendungsdaten.';
      message = step2AvailabilityProblemMessage();
      buttonText = 'Zurück zu Sendung';
      buttonId = 'backToStep2_inline';
      handler = goBackToStep2;
    }

    els.summaryBox.innerHTML = `
      <p><strong>${escapeHtml(title)}</strong></p>
      <p class="summary-muted">${escapeHtml(message)}</p>
      <p class="summary-back">
        <button type="button" class="btn-secondary" id="${escapeHtml(buttonId)}">${escapeHtml(buttonText)}</button>
      </p>
    `;

    document.getElementById(buttonId)?.addEventListener('click', handler);
  }

  function renderSummary(){
    if (!hasValidStep1() || !hasValidStep2()) {
      renderMissingData();
      return;
    }

    const abholstopps = Array.isArray(step1?.abholstopps) ? step1.abholstopps : [];
    const zustellstopps = Array.isArray(step1?.zustellstopps) ? step1.zustellstopps : [];
    const packs = Array.isArray(step2?.packstuecke) ? step2.packstuecke : [];

    let html = '';

    html += renderPriceBreakdown();

    if (abholstopps.length) {
      html += `<p class="summary-spaced"><strong>Abholung:</strong></p><ul>`;

      abholstopps.forEach(s => {
        const parts = [s.firma, s.kontakt, s.adresse].filter(Boolean).join(', ');
        const tel = normalizeText(s.telefon || '');
        const ref = normalizeText(s.referenz || '');

        html += `<li><strong>Stopp ${escapeHtml(s.index || '')}:</strong> ${escapeHtml(parts)}`;
        if (tel) html += `<div>(Tel: ${escapeHtml(tel)})</div>`;
        if (ref) html += `<div>(Ref: ${escapeHtml(ref)})</div>`;
        html += `</li>`;
      });

      html += `</ul>`;
    }

    if (zustellstopps.length) {
      html += `<p class="summary-spaced"><strong>Zustellung:</strong></p><ul>`;

      zustellstopps.forEach(s => {
        const parts = [s.firma, s.kontakt, s.adresse].filter(Boolean).join(', ');
        const tel = normalizeText(s.telefon || '');
        const ref = normalizeText(s.referenz || '');

        html += `<li><strong>Stopp ${escapeHtml(s.index || '')}:</strong> ${escapeHtml(parts)}`;
        if (tel) html += `<div>(Tel: ${escapeHtml(tel)})</div>`;
        if (ref) html += `<div>(Ref: ${escapeHtml(ref)})</div>`;
        html += `</li>`;
      });

      html += `</ul>`;
    }

    if (step1?.datum_abholung) {
      const d = fmtDate(step1.datum_abholung);
      const t = fmtTimeWindow(step1.zeitfenster_abholung || '', step1.fix_uhrzeit || '');

      html += `<p class="summary-spaced"><strong>Abholung:</strong> ${escapeHtml(d)}${t ? ` (${t})` : ''}</p>`;
    }

    if (step1?.datum_zustellung) {
      const d = fmtDate(step1.datum_zustellung);
      const t = fmtTimeWindow(step1.zeitfenster_zustellung || '', '');

      html += `<p><strong>Zustellung:</strong> ${escapeHtml(d)}${t ? ` (${t})` : ''}</p>`;
    }

    html += `<p class="summary-spaced"><strong>Packstücke:</strong></p><ul>`;

    packs.forEach((p, i) => {
      html += `<li><strong>Packstück ${i + 1}</strong><div>(${escapeHtml(formatArt(p.art))}): ${escapeHtml(p.menge || '1')} × ${escapeHtml(p.gewicht || '–')} kg ${escapeHtml(p.laenge || '–')} cm × ${escapeHtml(p.breite || '–')} cm × ${escapeHtml(p.hoehe || '–')} cm</div></li>`;
    });

    html += `</ul>`;

    const zoll = step2?.optionen?.zoll === 'ja' ? 'Ja' : 'Nein';

    html += `<p class="summary-spaced"><strong>Zollabwicklung:</strong> ${escapeHtml(zoll)}</p>`;

    els.summaryBox.innerHTML = html + `
      <p class="summary-back">
        <button type="button" class="btn-secondary" id="backToStep2_inline">Zurück zu Sendung</button>
      </p>
    `;

    document.getElementById('backToStep2_inline')?.addEventListener('click', goBackToStep2);
  }

  function setCustomerType(type){
    customerType = type === 'business' ? 'business' : 'private';

    const isBusiness = customerType === 'business';

    els.togBusiness.classList.toggle('active', isBusiness);
    els.togPrivate.classList.toggle('active', !isBusiness);
    els.togBusiness.setAttribute('aria-pressed', String(isBusiness));
    els.togPrivate.setAttribute('aria-pressed', String(!isBusiness));
    els.firmaWrap.classList.toggle('hidden', !isBusiness);
    els.firma.required = isBusiness;
    els.firma.setAttribute('aria-required', String(isBusiness));

    if (!isBusiness) {
      els.firma.value = '';
      clearFieldError(els.firma, els.err_firma);
    }

    markStep3Changed();

    if (hasTriedSubmit) validateAll(true);
    updateNextGating();
  }

  function validateAll(show){
    let ok = true;

    if (show) {
      showGlobal('');
    }

    const isBusiness = customerType === 'business';

    const firma = normalizeText(els.firma.value);
    const name = normalizeText(els.name.value);
    const adresse = normalizeText(els.adresse.value);
    const telefon = normalizePhone(els.telefon.value);
    const email = String(els.email.value || '').trim().toLowerCase();
    const hinweise = normalizeText(els.hinweise.value);

    if (isBusiness) {
      if (!firma) {
        setFieldError(els.firma, els.err_firma, 'Bitte Firma eingeben.', show);
        ok = false;
      } else if (firma.length < 2) {
        setFieldError(els.firma, els.err_firma, 'Bitte vollständigen Firmennamen eingeben.', show);
        ok = false;
      } else {
        setFieldError(els.firma, els.err_firma, '', show);
      }
    } else if (show) {
      clearFieldError(els.firma, els.err_firma);
    }

    if (!name) {
      setFieldError(els.name, els.err_name, 'Bitte Vor- und Nachnamen eingeben.', show);
      ok = false;
    } else if (name.length < 3) {
      setFieldError(els.name, els.err_name, 'Bitte vollständigen Namen eingeben.', show);
      ok = false;
    } else {
      setFieldError(els.name, els.err_name, '', show);
    }

    if (!adresse) {
      setFieldError(els.adresse, els.err_adresse, 'Bitte Rechnungsadresse eingeben.', show);
      ok = false;
    } else if (!looksCompleteBillingAddress(adresse)) {
      setFieldError(els.adresse, els.err_adresse, 'Bitte vollständige Rechnungsadresse mit Straße, Hausnummer, PLZ und Ort eingeben.', show);
      ok = false;
    } else {
      setFieldError(els.adresse, els.err_adresse, '', show);
    }

    if (!telefon || !isPhone(telefon)) {
      setFieldError(els.telefon, els.err_telefon, 'Bitte gültige Telefonnummer eingeben.', show);
      ok = false;
    } else {
      setFieldError(els.telefon, els.err_telefon, '', show);
    }

    if (!email || !isEmail(email)) {
      setFieldError(els.email, els.err_email, 'Bitte gültige E-Mail-Adresse eingeben.', show);
      ok = false;
    } else {
      setFieldError(els.email, els.err_email, '', show);
    }

    if (hinweise.length > 800) {
      showGlobal('Besondere Hinweise dürfen maximal 800 Zeichen enthalten.');
      ok = false;
    }

    if (!els.datenschutz.checked) {
      setFieldError(els.datenschutz, els.err_datenschutz, 'Bitte bestätigen Sie die Verarbeitung Ihrer Daten zur Buchungsbearbeitung.', show);
      ok = false;
    } else {
      setFieldError(els.datenschutz, els.err_datenschutz, '', show);
    }

    return ok;
  }

  function updateNextGating(){
    if (!hasValidStep1Base()) {
      els.nextBtn.disabled = true;
      els.ctaHint.textContent = 'Bitte zuerst Schritt 1 abschließen.';
      return;
    }

    if (!hasValidStep1Availability()) {
      els.nextBtn.disabled = true;
      els.ctaHint.textContent = 'Die Zeitfensterreservierung ist abgelaufen oder nicht mehr gültig. Bitte zurück zu Schritt 1.';
      return;
    }

    if (!hasValidStep2Base()) {
      els.nextBtn.disabled = true;
      els.ctaHint.textContent = 'Bitte zuerst Schritt 2 abschließen.';
      return;
    }

    if (!hasValidStep2Availability()) {
      els.nextBtn.disabled = true;
      els.ctaHint.textContent = 'Die Zeitfensterreservierung passt nicht mehr zu Schritt 2. Bitte zurück zu Schritt 2 oder Schritt 1.';
      return;
    }

    const ok = validateAll(false);

    els.nextBtn.disabled = !ok;
    els.ctaHint.textContent = ok
      ? 'Alles geprüft – Sie können fortfahren.'
      : 'Bitte Pflichtfelder ausfüllen – dann können Sie fortfahren.';
  }

  function buildPayload(finalSave){
    const now = new Date().toISOString();
    const isValid = hasValidStep1() && hasValidStep2() && validateAll(false);
    const priceSnapshot = buildPriceSnapshot();

    return {
      v: 4,
      booking_id: getBookingId(),
      pricing_version: priceSnapshot.pricing_version,
      step1_price_signature: step1?.price_signature || '',
      step2_signature: step2Signature(),
      step2_price_structure_signature: priceSnapshot.step2_price_structure_signature,
      step1_availability_required: step1RequiresAvailability(),
      step1_availability_valid: hasValidStep1Availability(),
      step1_availability_signature: getStep1Availability()?.signature || '',
      step1_availability_state_revision: getStep1Availability()?.state_revision || '',
      availability_hold_id: getStep1Availability()?.hold_id || '',
      availability_hold_expires_at: getStep1Availability()?.hold_expires_at || '',
      availability_snapshot: getStep1Availability(),
      step2_availability_valid: hasValidStep2Availability(),
      step2_availability_signature: step2?.step1_availability_signature || step2?.availability_snapshot?.signature || '',
      step2_availability_hold_id: step2?.availability_hold_id || step2?.availability_snapshot?.hold_id || '',
      valid: isValid,
      kundentyp: customerType,
      firma: customerType === 'business' ? normalizeText(els.firma.value) : '',
      name: normalizeText(els.name.value),
      adresse: normalizeText(els.adresse.value),
      telefon: normalizePhone(els.telefon.value),
      email: String(els.email.value || '').trim().toLowerCase(),
      hinweise: normalizeText(els.hinweise.value),
      datenschutz_akzeptiert: !!els.datenschutz.checked,
      request_mode: isRequestMode(),
      preis_basis: priceSnapshot.preis_basis.toFixed(2),
      preis_total: priceSnapshot.preis_total.toFixed(2),
      preis_komponenten_step1: step1?.preis_komponenten || null,
      preis_komponenten_step2: priceSnapshot.preis_komponenten,
      preis_komponenten: priceSnapshot.preis_komponenten,
      preis_zeilen: priceSnapshot.preis_zeilen,
      price_snapshot: priceSnapshot,
      created_at: createdAt,
      updated_at: now,
      zeitpunkt_bestellung: finalSave ? now : null
    };
  }

  function scheduleDraftSave(){
    if (isRestoring || isSubmitting || !hasValidStep1() || !hasValidStep2()) return;

    clearTimeout(saveTimer);

    saveTimer = setTimeout(() => {
      avalSave(KEY_STEP3, buildPayload(false));
    }, 250);
  }

  function markStep3Changed(){
    if (isRestoring || isSubmitting) return;

    clearDownstreamData();
    scheduleDraftSave();
  }

  function bindEvents(){
    document.getElementById('backToStep2')?.addEventListener('click', goBackToStep2);

    els.togPrivate.addEventListener('click', () => setCustomerType('private'));
    els.togBusiness.addEventListener('click', () => setCustomerType('business'));

    [els.firma, els.name, els.adresse, els.telefon, els.email, els.hinweise].forEach(el => {
      if (!el) return;

      el.addEventListener('input', () => {
        if (el === els.telefon) {
          el.value = normalizePhone(el.value);
        }

        if (el === els.email) {
          el.value = String(el.value || '').trim().toLowerCase();
        }

        if (el === els.adresse) {
          billingPlace = null;
        }

        markStep3Changed();

        if (hasTriedSubmit) validateAll(true);
        updateNextGating();
      });

      el.addEventListener('blur', () => {
        if (el === els.telefon) {
          el.value = normalizePhone(el.value);
        }

        if (el === els.email) {
          el.value = String(el.value || '').trim().toLowerCase();
        }

        markStep3Changed();

        if (hasTriedSubmit) validateAll(true);
        updateNextGating();
      });
    });

    els.datenschutz.addEventListener('change', () => {
      markStep3Changed();

      if (hasTriedSubmit) validateAll(true);
      updateNextGating();
    });

    els.form.addEventListener('submit', e => {
      e.preventDefault();

      hasTriedSubmit = true;
      root.classList.add('show-errors');

      if (!hasValidStep1() || !hasValidStep2()) {
        let msg = 'Bitte zuerst die vorherigen Buchungsschritte abschließen.';

        if (!hasValidStep1Base()) msg = 'Bitte zuerst Schritt 1 abschließen.';
        else if (!hasValidStep1Availability()) msg = step1AvailabilityProblemMessage();
        else if (!hasValidStep2Base()) msg = 'Bitte zuerst Schritt 2 abschließen.';
        else if (!hasValidStep2Availability()) msg = step2AvailabilityProblemMessage();

        showGlobal(msg);
        updateNextGating();
        return;
      }

      const ok = validateAll(true);
      updateNextGating();

      if (!ok) {
        showGlobal('Bitte prüfen Sie Ihre Eingaben.');
        focusAndScrollTo(firstErrorElement());
        return;
      }

      const payload = buildPayload(true);

      if (!payload.valid) {
        showGlobal('Bitte prüfen Sie Ihre Eingaben.');
        updateNextGating();
        return;
      }

      isSubmitting = true;
      clearTimeout(saveTimer);

      if (!avalSave(KEY_STEP3, payload)) {
        isSubmitting = false;
        showGlobal('Speichern der Kontaktdaten ist nicht möglich. Bitte deaktivieren Sie strikte Browser-Blocker oder nutzen Sie einen anderen Browser.');
        return;
      }

      location.href = NEXT_URL;
    });

    window.addEventListener('beforeunload', () => {
      if (isSubmitting || !hasValidStep1() || !hasValidStep2()) return;

      try {
        clearTimeout(saveTimer);
        avalSave(KEY_STEP3, buildPayload(false));
      } catch(e) {}
    });
  }

  function initAutocomplete(){
    try {
      const input = els.adresse;

      if (!input || !(window.google && google.maps && google.maps.places)) return;

      const ac = new google.maps.places.Autocomplete(input, {
        types: ['geocode'],
        componentRestrictions: { country: ['de'] },
        fields: ['formatted_address', 'address_components']
      });

      ac.addListener('place_changed', () => {
        billingPlace = ac.getPlace() || null;

        const fmt = formatPlaceOrResult(billingPlace, input.value);
        if (fmt) input.value = fmt;

        markStep3Changed();

        if (hasTriedSubmit) validateAll(true);
        updateNextGating();
      });
    } catch(e) {}
  }

  function restoreDraft(){
    const pre3 = avalLoad(KEY_STEP3);

    if (!pre3 || typeof pre3 !== 'object') {
      setCustomerType('private');
      return;
    }

    if (pre3.booking_id && pre3.booking_id !== getBookingId()) {
      avalRemove(KEY_STEP3);
      setCustomerType('private');
      return;
    }

    if (pre3.step2_signature && pre3.step2_signature !== step2Signature()) {
      avalRemove(KEY_STEP3);
      setCustomerType('private');
      return;
    }

    if (step1RequiresAvailability()) {
      if (!hasValidStep1Availability() || !hasValidStep2Availability()) {
        avalRemove(KEY_STEP3);
        setCustomerType('private');
        return;
      }

      const currentAvailability = getStep1Availability();
      const currentSignature = currentAvailability?.signature || '';
      const currentHoldId = currentAvailability?.hold_id || '';
      const draftSignature = pre3.step1_availability_signature || pre3.availability_snapshot?.signature || '';
      const draftHoldId = pre3.availability_hold_id || pre3.availability_snapshot?.hold_id || '';

      if (draftSignature && currentSignature && draftSignature !== currentSignature) {
        avalRemove(KEY_STEP3);
        setCustomerType('private');
        return;
      }

      if (draftHoldId && currentHoldId && draftHoldId !== currentHoldId) {
        avalRemove(KEY_STEP3);
        setCustomerType('private');
        return;
      }
    }

    isRestoring = true;

    try {
      createdAt = pre3.created_at || createdAt;

      setCustomerType(pre3.kundentyp === 'business' ? 'business' : 'private');

      if (pre3.firma) els.firma.value = pre3.firma;
      if (pre3.name) els.name.value = pre3.name;
      if (pre3.adresse) els.adresse.value = pre3.adresse;
      if (pre3.telefon) els.telefon.value = pre3.telefon;
      if (pre3.email) els.email.value = pre3.email;
      if (pre3.hinweise) els.hinweise.value = pre3.hinweise;

      els.datenschutz.checked = pre3.datenschutz_akzeptiert === true;
    } finally {
      isRestoring = false;
    }
  }

  function cleanMismatchedStoredData(){
    const pre3 = avalLoad(KEY_STEP3);
    const all = avalLoad(KEY_ALL);

    if (pre3?.booking_id && pre3.booking_id !== getBookingId()) avalRemove(KEY_STEP3);
    if (pre3?.step2_signature && pre3.step2_signature !== step2Signature()) avalRemove(KEY_STEP3);
    if (all?.step1?.booking_id && all.step1.booking_id !== getBookingId()) avalRemove(KEY_ALL);

    if (step1RequiresAvailability() && (!hasValidStep1Availability() || !hasValidStep2Availability())) {
      avalRemove(KEY_STEP3);
      avalRemove(KEY_ALL);
      return;
    }

    if (step1RequiresAvailability()) {
      const currentAvailability = getStep1Availability();
      const currentSignature = currentAvailability?.signature || '';
      const currentHoldId = currentAvailability?.hold_id || '';

      const pre3Now = avalLoad(KEY_STEP3);
      if (pre3Now && typeof pre3Now === 'object') {
        const pre3Signature = pre3Now.step1_availability_signature || pre3Now.availability_snapshot?.signature || '';
        const pre3HoldId = pre3Now.availability_hold_id || pre3Now.availability_snapshot?.hold_id || '';

        if (currentSignature && pre3Signature && currentSignature !== pre3Signature) avalRemove(KEY_STEP3);
        if (currentHoldId && pre3HoldId && currentHoldId !== pre3HoldId) avalRemove(KEY_STEP3);
      }
    }
  }

  function init(){
    step1 = avalLoad(KEY_STEP1);
    step2 = avalLoad(KEY_STEP2);

    bindEvents();
    cleanMismatchedStoredData();
    renderSummary();
    restoreDraft();

    root.classList.remove('show-errors');
    hasTriedSubmit = false;
    showGlobal('');
    updateNextGating();

    if (window.__avalGmapsReady && typeof window.__avalGmapsReady.then === 'function') {
      window.__avalGmapsReady.then(initAutocomplete).catch(function(){});
    } else {
      initAutocomplete();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
